import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                西瓜视频
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              西瓜视频致力于为广大用户提供最新、最全的高清影视资源。电影、电视剧、综艺、动漫一网打尽，免费在线观看，加载流畅不卡顿。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门推荐</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/v002" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  流浪地球3
                </Link>
              </li>
              <li>
                <Link to="/article/v007" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  繁花
                </Link>
              </li>
              <li>
                <Link to="/article/v003" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  庆余年第二季
                </Link>
              </li>
              <li>
                <Link to="/article/v001" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  长安三万里
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-background-300 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-background-300 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200" aria-label="B站">
                <i className="ri-bilibili-line text-background-300 text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2024 西瓜视频 xiguavideo.com 版权所有 | 本站内容仅供学习交流，请支持正版
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">
                用户协议
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}